export default __webpack_public_path__ + "static/media/3025.2fe93359.jpg";